import React, { useState, useEffect } from "react"
import CourseProgress from "../CourseProgress/CourseProgress"
import * as Style from "./CourseMainContent.module.scss"
import VideoPlayer from "../videoPlayer/VideoPlayer"
import Discussion from "../discussion/Discussion"
import Comments from "../discussion/Comments"
import Button from "../UI/button/Button"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import Stamat from "../animation/Animation"
import VideoInformation from "../VideoInformation/VideoInformation"
import { Link } from "gatsby"
import Checked from "../../images/checked.svg"
import Unchecked from "../../images/unchecked.svg"
import ArrowOpen from "../../images/arrowOpen.svg"
import ArrowClose from "../../images/arrowClose.svg"

const CourseMainContent = ({
  videos,
  lesson_id,
  info,
  strapi_id,
  commentData,
  watchedVids,
}) => {
  let watched = 0
  let all_videos = videos.length
  let video_free
  let free_videos = []
  let premium_videos = []
  let next_index
  let next_id
  let previous_index
  let previous_id

  const [showDescription, setShowDescription] = useState(false)
  const [watchedVideo, setWatchedVideo] = useState(false)

  useEffect(() => {
    if (watchedVids) {
      if (watchedVids.includes(strapi_id)) {
        setWatchedVideo(true)
      }
    }
  }, [watchedVids])

  const ShowDescription = () => {
    setShowDescription(true)
  }

  const HideDescription = () => {
    setShowDescription(false)
  }

  videos.forEach(video => {
    if (video.watched) {
      watched = watched + 1
    }
  })

  videos.forEach(video => {
    if (video.id == lesson_id) {
      if (video.free) {
        video_free = true
      } else {
        video_free = false
      }
    }
  })

  videos.forEach(video => {
    if (video_free) {
      if (video.free) {
        free_videos.push(video)
      }
    } else {
      if (!video.free) {
        premium_videos.push(video)
      }
    }
  })

  if (free_videos.length > 0) {
    free_videos.map((video, index) => {
      if (video.id == lesson_id) {
        next_index = index + 1
        previous_index = index - 1
      }
    })

    free_videos.map((video, index) => {
      if (index == next_index) {
        next_id = video.id
      }
      if (index == previous_index) {
        previous_id = video.id
      }
    })
  }

  if (premium_videos.length > 0) {
    premium_videos.map((video, index) => {
      if (video.id == lesson_id) {
        next_index = index + 1
        previous_index = index - 1
      }
    })

    premium_videos.map((video, index) => {
      if (index == next_index) {
        next_id = video.id
      }
      if (index == previous_index) {
        previous_id = video.id
      }
    })
  }

  return (
    <>
      <div className={Style.wrapper}>
        <div className={Style.col1}>
          <Button style={Style.button}>Плати</Button>
          <div className={Style.progress_btn_wrapper}>
            <CourseProgress
              watched={watchedVids ? watchedVids.length : 0}
              all_videos={all_videos}
            />
          </div>
          <div className={Style.video_wrapper}>
            {videos.map((video, index) => {
              if (video.id == lesson_id) {
                return (
                  <VideoPlayer
                    strapi_id={strapi_id}
                    key={index}
                    videoPlayer={video}
                  />
                )
              }
            })}
            <div className={Style.chicken}>
              <Stamat />
            </div>
          </div>
          <div className={Style.video_name_wrapper}>
            {videos.map((video, index) => {
              if (video.id == lesson_id) {
                return (
                  <div key={index} className={Style.titles}>
                    <div className={Style.title_watched}>
                      <div className={Style.title}>{video.title}</div>
                      <div className={Style.watched_wrapper}>
                        {watchedVideo ? <Checked /> : <Unchecked />}
                        <div
                          className={Style.watched}
                          style={
                            watchedVideo
                              ? { color: "#1A7196" }
                              : { color: "#A3A3A3" }
                          }
                        >
                          Watched
                        </div>
                      </div>
                      <div className={Style.arrows}>
                        {showDescription ? (
                          <ArrowClose onClick={HideDescription} />
                        ) : (
                          <ArrowOpen onClick={ShowDescription} />
                        )}
                      </div>
                    </div>
                    <div className={Style.subtitle}>{video.title}</div>
                  </div>
                )
              }
            })}
            <div className={Style.nav_buttons}>
              <Link
                style={{ pointerEvents: previous_id ? "auto" : "none" }}
                to={`../${previous_id}`}
              >
                <Button
                  style={`${Style.button} ${previous_id ? "" : Style.disabled}`}
                >
                  Previous Video
                </Button>
              </Link>
              <Link
                style={{ pointerEvents: next_id ? "auto" : "none" }}
                to={`../${next_id}`}
              >
                <Button
                  style={`${Style.button} ${next_id ? "" : Style.disabled}`}
                >
                  Next Video
                </Button>
              </Link>
            </div>
          </div>
        </div>
        <div className={Style.col2}>
          <Button style={Style.button}>Плати</Button>
          <div className={showDescription ? "" : `${Style.hideDesc}`}>
            {videos.map((video, index) => {
              if (video.id == lesson_id) {
                return <VideoInformation key={index} video={video} />
              }
            })}
          </div>
        </div>
      </div>
      <div className={Style.discussion_wrapper}>
        <Discussion
          // commentData={commentData}
          mode="main"
          strapi_id={strapi_id}
          discussion={info}
          // btnArrow={info.allStrapiHomePage.nodes[0].header.button.button_arrow.localFile}
        />
        <Comments
          // commentPost={comment}
          strapi_id={strapi_id}
          discussion={info}
          commentData={commentData}
        />
      </div>
    </>
  )
}

export default CourseMainContent
